<template>
  <div class="row align-items-center justify-content-center">
    <div class="col-12 col-md-8 col-lg-6 col-xl-4 px-lg-6 my-5">
      <h1>Set New Password</h1>

      <p>Please enter a new password for your account.</p>

      <div class="alert alert-danger" v-if="error" v-html="error"/>

      <form @submit.prevent>
        <div class="d-none form-group">
          <label>Email Address</label>
          <input type="email" class="form-control" readonly="readonly" :value="email">
        </div>
        <!-- /.form-group -->

        <div class="form-group">
          <label>New Password</label>
          <input
            type="password"
            class="form-control"
            name="password"
            v-validate="'required|password'"
            v-model="password"
          >

          <help-block field="password"/>
        </div>
        <!-- /.form-group -->

        <div class="form-group">
          <label>Repeat New Password</label>
          <input
            type="password"
            class="form-control"
            name="password_confirmation"
            v-validate="{ required: true, is: password, password: true }"
            v-model="passwordConfirmation"
            data-vv-as="password confirmation"
          >

          <help-block field="password_confirmation"/>
        </div>
        <!-- /.form-group -->

        <ladda-button
          type="submit"
          :validate="true"
          :click="resetPassword"
          :arguments="[payload]"
          :done="success"
          :failed="failed"
          class="btn btn-block btn-primary mb-3"
        >Set Password</ladda-button>

        <p class="mt-4 text-muted">
          Remember your password?
          <router-link :to="{ name: 'login' }">Sign In</router-link>.
        </p>
      </form>
    </div>
  </div>
  <!-- /.row -->
</template>

<script>
import { authMethods } from 'vx/helpers'

export default {
  props: {
    token: {
      required: true,
      type: String
    }
  },

  computed: {
    email () {
      return this.$route.query.email
    },

    payload () {
      return {
        password: this.password,
        password_confirmation: this.passwordConfirmation,
        email: this.email,
        token: this.token
      }
    }
  },

  data () {
    return {
      error: null,
      password: null,
      passwordConfirmation: null
    }
  },

  created () {
    if (this.email === undefined || this.email === null) {
      this.$router.replace({ name: 'login' })
    }
  },

  methods: {
    ...authMethods,

    success () {
      this.$router.push({ name: 'login' })

      this.$noty.success('Your password has been reset.')
    },

    failed (error) {
      if (error.response && error.response.status === 422 && error.response.data.errors.generic) {
        this.error = error.response.data.errors.generic.pop()
      }
    }
  }
}
</script>
